// extracted by mini-css-extract-plugin
export default {"navmain":"Sideicons_navmain__hpTjn","navbarmain":"Sideicons_navbarmain__EsRfu","writtenlogo":"Sideicons_writtenlogo__e5+7r","navbarcontent":"Sideicons_navbarcontent__Z0rN-"};